import { FeatureFlagKey } from "@swivl-mono/types";
import { HeaderTabsComponent } from "@swivl-mono/ui";
import { useSearchParams } from "react-router-dom";

import { isFeatureEnabled } from "../../../Helpers/FeatureFlags/isFeatureEnabled";

/**
 * The CRM top-stripe nav (same pattern as Property Manager v3): the surface title plus
 * header tabs for the CRM pages. The tabs are anchored at the border between the CRM
 * locations sidebar (w-[300px]) and the content, with a small margin — like the
 * Property Manager stripe. Tab links carry the sidebar's org/group/location scope so
 * switching pages keeps the current selection; page-specific filters do not carry.
 */
export function CRMNavContent(): React.ReactElement {
  const [searchParams] = useSearchParams();

  const scopeParams = new URLSearchParams();
  for (const key of ["groupId", "locationId", "viewAll"]) {
    const value = searchParams.get(key);
    if (value) scopeParams.set(key, value);
  }
  const scope = scopeParams.toString();
  const scopeSearch = scope ? `?${scope}` : "";

  // Users is the legacy CRM page. The other two are Snowy surfaces (v3 sequences, SMS
  // campaigns) — a legacy org saw blank pages behind them (ENG-3475). The Sequences page
  // also sits behind the sequences_page flag (ENG-3542); it absorbed the former Sequence
  // Suppressions page (ENG-3811), whose route now redirects here.
  const snowy = isFeatureEnabled(FeatureFlagKey.Snowy);
  const sequencesPage = snowy && isFeatureEnabled(FeatureFlagKey.SequencesPage);
  const items = [
    { to: `/crm${scopeSearch}`, label: "Users", excludeMatch: "/crm/" },
    ...(sequencesPage ? [{ to: `/crm/sequence-events${scopeSearch}`, label: "Sequences" }] : []),
    ...(snowy ? [{ to: `/crm/sms-campaigns${scopeSearch}`, label: "SMS Campaigns" }] : [])
  ];

  return (
    <>
      <span className="font-poppins text-lg font-semibold">CRM</span>
      {/* Absolute against the fixed NavBar — x=0 is the viewport edge, so left matches
          the sidebar width and the tabs start right at the sidebar/content border. */}
      <div className="absolute inset-y-0 left-[300px] ml-3 flex items-center">
        <HeaderTabsComponent items={items} />
      </div>
    </>
  );
}
